export const CONTEXTS = {
  VC_V1: 'https://www.w3.org/2018/credentials/v1',
  RL_V1: 'https://w3id.org/vc-revocation-list-2020/v1',
};
